import {useAuthUser} from 'react-auth-kit'

const CAMPAIGN_URL = process.env.REACT_APP_CAMPAIGN_UI_URL

export default function Campaign() {
  const authUser = useAuthUser()
  const currentDateTime = new Date().toISOString()

  return (
    <>
      <div className='card rounded-0 w-100 '>
        <div className='min-h-100'>
          <iframe
            title='Promo'
            src={`${CAMPAIGN_URL}/dashboard?userID=${
              authUser().id
            }&v=${currentDateTime}&parentUrl=${window.location.origin}&token=${
              authUser().token
            }&timestamp=${new Date().getTime()}`}
            width='100%'
            className='h-100'
          ></iframe>
        </div>
      </div>
    </>
  )
}
